import farmTourVideo from '../assets/videos/farm-tour.mp4';
import processingLineVideo from '../assets/videos/processing-line.mp4';

// Import certificate images
import cert1 from '../assets/images/certificates/IMG20240515111723-scaled-e1715777732185-1024x686.jpg';
import cert2 from '../assets/images/certificates/IMG20240515111729-scaled-e1715778008762-1024x748.jpg';
import cert3 from '../assets/images/certificates/mmexport1715777380672-scaled-e1715777674876-1024x728.jpg';
import cert4 from '../assets/images/certificates/ok-scaled-e1715778134474-1024x736.jpg';

// Import gallery images
import milkBottles from '../assets/images/gallery/milk bottles.jpg';
import jojomilk from '../assets/images/gallery/jojo milk.jpg';
import strawberryMilk from '../assets/images/gallery/kid with strawberry milk.jpg';
import yolyMango from '../assets/images/gallery/yoly mango flavour.jpg';
import yolyJuices from '../assets/images/gallery/yoly different flavoured juices.jpg';
import strawberryDrink from '../assets/images/gallery/strawberry flavoured drink.jpg';
import factory from '../assets/images/gallery/factory.jpg';
import factoryTour from '../assets/images/gallery/factory tour.jpg';
import farm from '../assets/images/gallery/farm 2.jpg';
import field from '../assets/images/gallery/field.jpg';
import milingCows from '../assets/images/gallery/milking cows.jpg';
import kidsField from '../assets/images/gallery/kids in field.jpg';
import kidsFootball from '../assets/images/gallery/kids football team.jpg';
import kidsDrinking from '../assets/images/gallery/kids drinkin the milk.jpg';
import launchPromo1 from '../assets/images/gallery/launch promo img.jpg';
import launchPromo2 from '../assets/images/gallery/launch promo img 2.jpg';
import launchPromo3 from '../assets/images/gallery/launch promo 3.jpg';
import launchPromo4 from '../assets/images/gallery/launch promo 4.jpg';
import financeMinister from '../assets/images/gallery/finance minister visit.jpg';
import primeMinister from '../assets/images/gallery/prime minister visit.jpg';
import kidsWithJojo from '../assets/images/gallery/kids with jojo milk.jpg';
import kidsStrawberry from '../assets/images/gallery/kid with strawberry milk 2.jpg';
import kidsFootball2 from '../assets/images/gallery/kids football team 2.jpg';

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Products', path: '/products' },
  { label: 'About', path: '/about' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

export const heroContent = {
  image: yolyJuices,
  eyebrow: 'Farm-to-table nourishment',
  heading: "Fresh, natural goodness from Sidama's heartland",
  description:
    'Bringing you dairy and juice products crafted with care, tradition, and love from our vibrant farm community.',
  primaryCta: { label: 'Explore Products', to: '/products' },
  secondaryCta: { label: 'Trade & Distribution', to: '/contact' },
  stats: [
    { value: '18+', label: 'Community farmers' },
    { value: '12K', label: 'Liters processed weekly' },
    { value: '42%', label: 'Lower emissions across logistics' },
  ],
};

export const productHighlights = [
  {
    title: 'Fresh Milk',
    image: milkBottles,
    description:
      'Pasteurized fresh milk rich in nutrients, fortified with Vitamin D, and delivered within 12 hours of milking.',
    details: ['100% natural', 'Cold-chain logistics', 'Reusable packaging program'],
  },
  {
    title: 'Creamy Yogurt',
    image: jojomilk,
    description:
      'Natural yogurt cultured from our farm’s fresh milk and paired with seasonal fruits sourced from Sidama growers.',
    details: ['Live probiotic cultures', 'No artificial sweeteners', 'Custom catering sizes'],
  },
  {
    title: 'Fruit Juice',
    image: yolyMango,
    description:
      'Vibrant juice blends made from sun-ripened fruits, bottled on-site to lock in the farm-fresh flavors.',
    details: ['No added sugar', 'Cold-pressed methods', 'Available in 6 signature flavors'],
  },
];

export const storyTimeline = [
  { year: '2020', event: 'MoU with Yirgalem Industry Park signed on 16 Jan 2020; operations aligned with 2019 investment planning.' },
  { year: '2021', event: 'Duoley Food Processing PLC was established with a vision to bring premium dairy products to the Ethiopian market.' },
  { year: '2022', event: 'Started production of milk and juice products, focusing on quality and natural ingredients.' },
  { year: 'Future', event: 'Expanding product range and distribution network across Ethiopia and beyond.' },
];

export const values = [
  {
    title: 'Quality First',
    description: 'We never compromise on quality, ensuring every product meets the highest standards.',
  },
  {
    title: 'Community Focus',
    description: 'We support local farmers and contribute to the development of our community.',
  },
  {
    title: 'Customer Love',
    description: 'Our customers are at the heart of everything we do, driving our innovation and improvement.',
  },
];

export const galleryImages = [
  { src: factory, alt: 'Duoley processing facility' },
  { src: factoryTour, alt: 'Factory tour with visitors' },
  { src: farm, alt: 'Sidama farmland' },
  { src: field, alt: 'Green fields at harvest' },
  { src: milingCows, alt: 'Milking cows on the farm' },
  { src: kidsField, alt: 'Kids in the field' },
  { src: kidsFootball, alt: 'Community kids football team' },
  { src: kidsDrinking, alt: 'Kids enjoying fresh milk' },
  { src: milkBottles, alt: 'Fresh milk bottles' },
  { src: jojomilk, alt: 'Jojo milk product' },
  { src: strawberryMilk, alt: 'Strawberry flavored milk' },
  { src: yolyMango, alt: 'Yoly mango juice' },
  { src: yolyJuices, alt: 'Yoly juice collection' },
  { src: strawberryDrink, alt: 'Strawberry flavored drink' },
  { src: launchPromo1, alt: 'Launch promotion event' },
  { src: launchPromo2, alt: 'Launch promotion moment' },
  { src: launchPromo3, alt: 'Launch promotion celebration' },
  { src: launchPromo4, alt: 'Launch promotion showcase' },
  { src: financeMinister, alt: 'Finance minister visit' },
  { src: primeMinister, alt: 'Prime minister visit' },
  { src: kidsWithJojo, alt: 'Kids with Jojo milk' },
  { src: kidsStrawberry, alt: 'Kids with strawberry milk' },
  { src: kidsFootball2, alt: 'Community football team moment' },
];


export const blogPosts = [
  {
    slug: 'sustainable-dairy-farming',
    title: 'Sustainable Dairy Farming',
    excerpt: 'How our regenerative farming practices support the environment and empower the Sidama community.',
    category: 'Sustainability',
  },
  {
    slug: 'nutritional-benefits-of-milk',
    title: 'Nutritional Benefits of Milk',
    excerpt: 'Discover the science-backed health benefits of retaining fresh milk in daily diets.',
    category: 'Nutrition',
  },
  {
    slug: 'farm-to-bottle-juices',
    title: 'Juice Production: From Farm to Bottle',
    excerpt: 'The cold-pressed process that keeps our fruit juice blends vibrant, honest, and delicious.',
    category: 'Process',
  },
];

export const contactDetails = {
  email: 'info@duoleyfood.com',
  phone: '+251 976 575 757',
  phoneTel: '+251 11 557 4620',
  address: 'Bambis, Black Gold Complex, 3rd floor, Addis Ababa, Ethiopia',
  officeHours: 'Mon–Fri: 08:30 – 17:30, Sat: 08:30 – 12:00',
  mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d246.28603497943234!2d38.7713725492358!3d9.011052861927837!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b856c73560ef3%3A0x7a0bf20abf762bab!2sBambis%20Hacomal%20Apartment!5e0!3m2!1sen!2set!4v1761572846663!5m2!1sen!2set',
};

export const socialLinks = [
  { label: 'Facebook', url: 'https://www.facebook.com/duoleyfood', handle: '@duoleyfood' },
  { label: 'Instagram', url: 'https://www.instagram.com/duoleyfood', handle: '@duoleyfood' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/company/duoleyfood', handle: 'Duoley Food Processing PLC' },
  { label: 'YouTube', url: 'https://www.youtube.com/@duoleyfood', handle: '@duoleyfood' },
  { label: 'TikTok', url: 'https://www.tiktok.com/@duoleyfood', handle: '@duoleyfood' },
];

export const distributionPartners = {
  partners: [
    {
      name: 'Sidama Cooperative Union',
      focus: 'Dairy collection and farmer development',
      location: 'Hawassa, Sidama Region',
      contact: '+251 912 345 678',
    },
    {
      name: 'Blue Nile Hospitality Group',
      focus: 'Hotel and resort food service',
      location: 'Addis Ababa & Bahir Dar',
      contact: 'procurement@bluenilehospitality.com',
    },
    {
      name: 'EthioFresh Retailers',
      focus: 'Specialty grocers & premium retail',
      location: 'Addis Ababa metro',
      contact: '+251 955 321 654',
    },
  ],
  distributors: [
    {
      name: 'Addis Cold Chain Logistics',
      coverage: 'Greater Addis Ababa & Oromia',
      contact: 'logistics@addiscoldchain.com',
      phone: '+251 911 222 333',
    },
    {
      name: 'Southern Highlands Distribution',
      coverage: 'Sidama, SNNPR, Hawassa corridor',
      contact: 'sales@southernhighlandsdist.et',
      phone: '+251 913 454 565',
    },
    {
      name: 'EastGate Trading PLC',
      coverage: 'Dire Dawa, Harar, Somali region',
      contact: 'orders@eastgateplc.com',
      phone: '+251 920 777 888',
    },
  ],
};

export const mediaAssets = {
  farmTour: farmTourVideo,
  processingLine: processingLineVideo,
  farmTourYoutube: 'https://www.youtube.com/embed/FIYnwdW-D5I?controls=1&modestbranding=1',
  processingLineYoutube: 'https://www.youtube.com/embed/D7oVF4b-vwE?controls=1&modestbranding=1',
};

export const seoByRoute = {
  '/': {
    title: 'Duoley Food Processing PLC | Farm-Fresh Dairy & Juice',
    description:
      'Explore Duoley’s farm-to-table dairy and juice range crafted in Sidama with sustainability and community front of mind.',
  },
  '/products': {
    title: 'Products | Duoley Food Processing PLC',
    description:
      'Browse Duoley’s premium dairy and juice products made from fresh Sidama ingredients and rigorous quality controls.',
  },
  '/about': {
    title: 'About Duoley | Heritage & Sustainability',
    description:
      'Learn about Duoley’s roots, values, and the dedicated farmers advancing sustainable food processing in Sidama.',
  },
  '/gallery': {
    title: 'Gallery | Duoley Moments',
    description:
      'Step inside the Duoley experience through curated visuals of our farms, products, and community.',
  },
  '/blog': {
    title: 'Insights & Stories | Duoley Blog',
    description:
      'Stay updated with Duoley’s latest stories on sustainability, nutrition, and farm-to-table innovation.',
  },
  '/contact': {
    title: 'Contact Duoley | Distribution & Partnerships',
    description:
      'Connect with Duoley for distribution, partnerships, and general inquiries about our dairy and juice portfolio.',
  },
};

export const teamMembers = [
  {
    name: 'Founder & CEO',
    role: 'Visionary Leadership',
    description: 'Leading Duoley with a passion for sustainable food processing and community empowerment.',
    image: null, // Replace with actual team member image
  },
  {
    name: 'Operations Manager',
    role: 'Production Excellence',
    description: 'Ensuring every batch meets our rigorous quality standards and cold-chain compliance.',
    image: null, // Replace with actual team member image
  },
  {
    name: 'Community Liaison',
    role: 'Farmer Relations',
    description: 'Building strong partnerships with our network of smallholder farmers across Sidama.',
    image: null, // Replace with actual team member image
  },
  {
    name: 'Quality Assurance',
    role: 'Lab & Testing',
    description: 'Daily benchmarks validating protein, probiotic activity, and nutrient retention.',
    image: null, // Replace with actual team member image
  },
];

export const certificates = [
  {
    title: 'IYF Christmas Concert 2024',
    organization: 'International Youth Fellowship',
    image: cert1,
    description: 'Certificate of Appreciation for sponsoring the IYF Christmas Concert at the Sheraton Hotel.',
    date: '1st January, 2024',
    signatory: 'Rev. Dr. Ock Soo Park, Founder of International Youth Fellowship',
  },
  {
    title: 'IYF March 2023 Activities',
    organization: 'International Youth Fellowship',
    image: cert2,
    description: 'Presented in gratitude for support towards 2023 March IYF Activities for youth development in Ethiopia.',
    date: '2023',
    signatory: 'Jae Hyub Kim, Chairman, International Youth Fellowship, Ethiopia',
  },
  {
    title: 'Ethiopia Tamirt Expo 2024',
    organization: 'Ethiopia Tamirt Expo',
    image: cert3,
    description: 'Awarded for contribution to foreign currency earnings in the manufacturing sector, achieving third place.',
    date: '2022/23 Fiscal Year',
    signatory: 'Ethiopia Tamirt EXPO',
  },
  {
    title: 'Full Salvation Charity Organization',
    organization: 'Full Salvation Charity',
    image: cert4,
    description: 'Certificate appreciating support in charitable endeavours through materials, advice, and financial aid.',
    date: '2014 ዓ.ም. (Ethiopian Calendar)',
    signatory: 'Full Salvation Charity Organization',
  },
];

export const testimonials = [
  {
    image: primeMinister,
    title: 'Prime Minister of Ethiopia',
    name: 'Dr. Abiy Ahmed',
  },
  {
    image: financeMinister,
    title: 'Minister of Finance of Ethiopia',
    name: 'Ahmed Shide',
  },
];
